import { CART_QUERY, ORDER_INTENT_QUERY, CHECK_VOUCHER_CODE, } from "./queries.shop.js";
import { addSkuItemInput, cartItemPricingChangeInput, cartResult, cartCustomerInputSchema, hydrateCartInput, cartMetaInputSchema, } from "./schemas.js";
import { ADD_CART_ITEM, ADD_SKU_ITEM, CHANGE_CART_ITEM_PRICING, FULFILL_CART, HYDRATE_CART, PLACE_CART, REMOVE_CART_ITEM, SET_CUSTOMER, SET_META, } from "./mutations.shop.js";
import { graphql } from "@cappelendamm/crystallize-types/shop/gql";
import { graphql as graphqlShopAdmin } from "@cappelendamm/crystallize-types/shopAdmin/gql";
import { FREE_SHIPPING_PROMOTION } from "./queries.shopAdmin.js";
export const getCart = async ({ cartId }, client) => {
    const result = await client.shop.request(graphql(CART_QUERY), { cartId });
    return cartResult.parse(result.cart);
};
export const getOrderIntent = async ({ cartId }, client) => {
    const result = await client.shop.request(graphql(ORDER_INTENT_QUERY), {
        cartId,
    });
    return result.orderIntent?.order ?? null;
};
export const hydrateCart = async (cart, client) => {
    const input = hydrateCartInput.parse(cart);
    const result = await client.shop.request(graphql(HYDRATE_CART), { input });
    return cartResult.parse(result.hydrate);
};
export const setCartCustomer = async ({ customer, cartId, }, client) => {
    const input = cartCustomerInputSchema.parse(customer);
    const result = await client.shop.request(graphql(SET_CUSTOMER), {
        input,
        cartId,
    });
    return cartResult.parse(result.setCustomer);
};
export const setCartMeta = async ({ cartId, cartMetaInput, }, client) => {
    const input = cartMetaInputSchema.parse(cartMetaInput);
    const result = await client.shop.request(graphql(SET_META), {
        meta: input.meta,
        merge: input.merge,
        cartId,
    });
    return cartResult.parse(result.setMeta);
};
export const addSkuItem = async ({ skuItem, cartId, }, client) => {
    const input = addSkuItemInput.parse(skuItem);
    const result = await client.shop.request(graphql(ADD_SKU_ITEM), {
        input,
        cartId,
    });
    return cartResult.parse(result.addSkuItem);
};
export const removeCartItem = async ({ cartId, sku, quantity }, client) => {
    const result = await client.shop.request(graphql(REMOVE_CART_ITEM), {
        sku,
        cartId,
        quantity,
    });
    return cartResult.parse(result.removeCartItem);
};
export const addCartItem = async ({ cartId, sku, quantity }, client) => {
    const result = await client.shop.request(graphql(ADD_CART_ITEM), {
        sku,
        cartId,
        quantity,
    });
    return cartResult.parse(result.addCartItem);
};
export const placeCart = async ({ cartId }, client) => {
    const result = await client.shop.request(graphql(PLACE_CART), {
        cartId,
    });
    return cartResult.parse(result.place);
};
export const checkVoucherCode = async ({ voucher }, client) => {
    const result = await client.shop.request(graphql(CHECK_VOUCHER_CODE), {
        voucher,
    });
    return result.validateVoucher;
};
export const getFreeShippingPromotion = async ({ identifier }, client) => {
    const result = await client.shopAdmin.request(graphqlShopAdmin(FREE_SHIPPING_PROMOTION), {
        identifier,
    });
    return result.promotion;
};
export const fulfillCart = async ({ cartId, orderId }, client) => {
    const result = await client.shop.request(graphql(FULFILL_CART), {
        cartId,
        orderId,
    });
    return cartResult.parse(result.fulfill);
};
export const changeCartItemPricing = async ({ cartId, item, }, client) => {
    const input = cartItemPricingChangeInput.parse(item);
    const result = await client.shop.request(graphql(CHANGE_CART_ITEM_PRICING), {
        cartId,
        input,
    });
    return cartResult.parse(result.changeCartItemPricing);
};
